<template>
  <Content id="roles">
    <div slot="search">
      <Form :label-width="50" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="角色名" :label-width="60"><Input v-model="search.name"/></FormItem></Col>
          <Col>
            <FormItem label="状态">
              <Select v-model="search.status">
                <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col><div style="display:flex;">&nbsp;&nbsp;<Button type="primary" @click="query">查询</Button></div></Col>
        </Row>
      </Form>

      <div slot="extra" style="margin-bottom: 5px; display: flex;width: 100%" >
        <div style="float: left;">
          <Button size="small" icon="md-add" style="margin-right: 5px;" @click="handleCreate" type="primary">添加</Button>
        </div>
      </div>
    </div>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" highlight-current-row highlight-selection-row row-key="id"
              :row-class-name="tableRowClassName" @row-click="selectrow" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center', 'height':'40px'}" :max-height="tableHeight">

      <el-table-column fixed align="center" prop="id" label="编号" min-width="35"/>
      <el-table-column align="center" prop="name" label="角色名" min-width="150"/>
      <el-table-column align="center" prop="level" label="级别" min-width="100" v-if="this.userType < 3">
        <template slot-scope="{row}">{{ convertLevel(row.level) }}</template>
      </el-table-column>
      <el-table-column align="center" prop="parentName" label="上级" min-width="150"/>
      <el-table-column align="center" prop="creator" label="创建人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.creatorAccount }}</div>
          <div>{{ row.creator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间" min-width="100"/>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="最后操作时间" min-width="100"/>
      <el-table-column align="center" prop="status" label="状态" min-width="60">
        <template slot-scope="{row}">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="handleEditStatus(row, null, row.status)"/>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="80" id="elPopoverVisible">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="handleUser(row)" v-if="userType <= 3">用户</el-button>&nbsp;
          <el-button type="text" size="medium" @click="handleEdit(row)">编辑</el-button>&nbsp;
          <!--
          <el-popover placement="top" min-width="150" v-model="deleteVisible['visible_' + row.id]">
            <p style="display: flex; -webkit-box-align: center; align-items: center; line-height: 35px; font-size: 16px; ">
              <i class="el-popconfirm__icon el-icon-info" style="color: red;"/>是否确定删除？
            </p>
            <div style="text-align: right; margin: 0;line-height: 30px;">
              <el-button size="small" type="text" @click="cancel(row)" style="padding: 7px 15px;font-size: 12px;border-radius: 3px;background: #FFFFFF;border: 1px solid #DCDFE6;color: #606266;">取消</el-button>
              <el-button type="primary" size="small" @click="del(row)">确定</el-button>
            </div>
            <a slot="reference" style="color: #409EFF;">删除</a>
          </el-popover>
          -->
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]" @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <RoleEdit ref="edit" @on-update="handleDataList" />

    <Modal ref="modalRef" v-model="userWindow" width="50%" :title="userTitle" :styles="{'top':'60px'}" :mask-closable="false" :footerHide="true">
      <usersManage ref="user"/>
    </Modal>

  </Content>
</template>
<script>
import {
  _delRole,
  _getRoleList,
  _updateStatus
} from "@/services/manage/roles";
import RoleEdit from "./RolesEdit";
import usersManage from "./Users.vue"
export default {
  name: "Roles",
  components: {
    RoleEdit,
    usersManage
  },
  data() {
    return {
      search: {
        name: "",
        status: "",
      },
      userType : null,
      tableHeight: 0,
      currentRowIndex: null,
      userWindow:false,
      userTitle:"用户列表",
      deleteVisible:{},
      dataList: [],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      statusList:[
        {label: '全部', value: ''},
        {label: '启用', value: 1},
        {label: '停用', value: 2},
      ],
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    this.userType = this.$userSession.getUserType();
    this.handleDataList();
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    convertLevel(level){
      if (level == 1){
        return "超级管理员";
      }else if (level == 2) {
        return "全国级管理员";
      }else if (level == 3) {
        return "省级管理员";
      }else if (level == 4) {
        return "市级管理员";
      }else if (level == 5) {
        return "区级管理员";
      }else if (level == 6) {
        return "街道管理员";
      }else if (level== 7) {
        return "普通角色";
      }else{
        return "";
      }
    },
    query() {
      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _getRoleList({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        if (res.errcode == 1){
          if (res.errcode === 1 && res.data && res.data.records && res.data.records.length > 0) {
            res.data.records.forEach(item => {
              this.deleteVisible['visible_' + item.id] = false;
            })
          }

          this.dataList = res.data.records;
          this.pageList.total = res.data.total;
        } else {
          this.$message.error(res.errmsg)
        }
      }).catch(() => {});
    },
    // 新增界面
    handleCreate() {
      this.$refs["edit"].handleModal(true,"新增角色");
    },
    handleUser(row) {
      this.userTitle = row.name;
      this.userWindow = true;
      this.$refs["user"].openWindow(row);
    },
    handleEdit(row) {
      this.$refs["edit"].handleModal(false,"角色编辑", row); // 显示编辑模态框
    },
    cancel(){
      this.$nextTick(()=>{
        document.getElementById('elPopoverVisible').click();
      })
    },
    del(row) {
      _delRole({id: row.id}).then(res=>{
        if (res && res.errcode && res.errcode === 1){
          this.handleDataList();
          this.$message.success("删除成功")
        }else{
          this.$message.error(res.errmsg)
        }
      })
    },
    handleEditStatus(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用" : "停用"}${row.name}吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then((result)=>{
            _updateStatus({id:row.id, status: targetValue}).then(res =>{
              if (res.errcode === 1) {
                this.handleDataList();
              }else {
                this.$message.error(res.errmsg);
                reject()
              }
            }).catch(() => {
              reject()
            });
          }).catch(function (e) {
            if (e === 'cancel' || e === 'close') {
              row.status = (targetValue === 1 ? 2 : 1);
            }
          })
        });
      }
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e){
      this.pageList.currentPage=e
      this.handleDataList();
    },
    chagepagesize(e){
      this.pageList.pageSize=e
      this.handleDataList();
    },
  },
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 6px;vertical-align: top;zoom: 1;}
</style>
